import { useMemo } from 'react';

export default function useCsrfToken() {
  return useMemo(() => {
    const meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.content : '';
  }, []);
}
